import { render, staticRenderFns } from "./SubmitFeedbackTemplate.vue?vue&type=template&id=78219ab2&scoped=true"
import script from "./SubmitFeedbackTemplate.vue?vue&type=script&lang=js"
export * from "./SubmitFeedbackTemplate.vue?vue&type=script&lang=js"
import style0 from "./SubmitFeedbackTemplate.vue?vue&type=style&index=0&id=78219ab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78219ab2",
  null
  
)

export default component.exports